module.exports = __webpack_public_path__ + "media/images/case-studies/baw-baw-8313e224a4fe2c29b1214b59206af8f9.png";